<p>dashboard-host-settings works!</p>
